import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppStore } from '../stores/app-store';
import { Company } from '../shared/services/api/company-api.service';
import { SelectedWorkspaceStore } from '../stores/selected-workspace.store';
import {Workspace} from "../pages/workspace/features/create-workspace/services/workspace-data.service";

@Injectable()
export class HttpHeadersInterceptor implements HttpInterceptor {
  private currentCompany: Workspace | null = null;
  constructor(
    private workspaceStore: SelectedWorkspaceStore,
    private appStore: AppStore,
  ) {
    this.workspaceStore.storeState$.subscribe((it) => {
      this.currentCompany = it.project;
    });
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.currentCompany && !this.appStore.initialReferrerUUID.value) {
      return next.handle(request);
    }

    if (
      this.currentCompany &&
      !request.url.includes('auth') &&
      !request.url.includes('registration') &&
      !request.url.includes('social') &&
      !request.url.includes('password') &&
      !request.url.includes('geoserver.perare.io') &&
      !request.url.includes('geoserver.dev') &&
      !request.url.includes('geo2.perare.io')
    ) {
      const company = this.currentCompany;
      const uuid = company.id;

      request = request.clone({
        setHeaders: {
          'x-company': uuid,
        },
      });
    }

    if (
      this.appStore.initialReferrerUUID.value &&
      !request.url.includes('auth') &&
      !request.url.includes('registration') &&
      !request.url.includes('social') &&
      !request.url.includes('password') &&
      !request.url.includes('geoserver.perare.io') &&
      !request.url.includes('geoserver.dev') &&
      !request.url.includes('geo2.perare.io')
    ) {
      request = request.clone({
        setHeaders: {
          'x-referer-link': this.appStore.initialReferrerUUID.value,
        },
      });
    }
    return next.handle(request);
  }
}
